import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Test from '../pages/Test'
import SignIn from '../pages/auth/SignIn'
import AdminDashboard from '../pages/admin/AdminDashboard'
import AdminLayout from './layouts/AdminLayout'
import AddSkill from '../pages/admin/AddSkill'
import Countries from '../pages/admin/country/Countries'
import AddCountry from '../pages/admin/country/AddCountry'
import EditCountry from '../pages/admin/country/EditCountry'
import Branches from '../pages/admin/branch/Branches'
import AddBranch from '../pages/admin/branch/AddBranch'
import EditBranch from '../pages/admin/branch/EditBranch'
import AddDepartment from '../pages/admin/department/AddDepartment'
import EditDepartment from '../pages/admin/department/EditDepartment'
import Departments from '../pages/admin/department/Departments'
import { UserInfoProvider } from '../provider/UserInfoProvider'
import Roles from '../pages/admin/role/Roles'
import AddRole from '../pages/admin/role/AddRole'
import EditRole from '../pages/admin/role/EditRole'
import Technologies from '../pages/admin/technology/Technologies'
import AddTechnology from '../pages/admin/technology/AddTechnology'
import EditTechnology from '../pages/admin/technology/EditTechnology'
import Responsibilities from '../pages/admin/responsibility/Responsibilities'
import AddResponsibility from '../pages/admin/responsibility/AddResponsibility'
import EditResponsibility from '../pages/admin/responsibility/EditResponsibility'
import Users from '../pages/admin/user/Users'
import AddUser from '../pages/admin/user/AddUser'
import EditUser from '../pages/admin/user/EditUser'
import Projects from '../pages/project/Projects'
import AddProject from '../pages/project/AddProject'
import EmployeeLayout from './layouts/EmployeeLayout'
import UserDashboard from '../pages/employee/UserDashboard'
import MyTechnologies from '../pages/employee/MyTechnologies'
import AddSelfTechnology from '../pages/admin/technology/AddSelfTechnology'
import UserProfilePage from '../pages/employee/UserProfilePage'
import UserDetails from '../pages/admin/user/UserDetails'
import ChangeDefaultPassword from '../pages/auth/ChangeDefaultPassword'
import ProjectDetailsPage from '../pages/project/ProjectDetailsPage'
import ForgotPassword from '../pages/auth/ForgotPassword'

export default function RouteApp() {
    return (
        <UserInfoProvider>
            <Routes>
                <Route path='/' element={<SignIn />} />
                <Route path='/sign-in' element={<SignIn />} />
                <Route path='/forgot-password' element={<ForgotPassword />} />
                <Route path='/reset-forgot-password' element={<ForgotPassword />} />
                <Route path='/change-default-password' element={<ChangeDefaultPassword />} />
                <Route path='/test' element={<Test />} />

                {/* Protected Routes Admin */}
                <Route element={<AdminLayout />}>
                    <Route path='/admin-dashboard' element={<AdminDashboard />} />
                    <Route path='/add-skill' element={<AddSkill />} />

                    {/* Country Routes */}
                    <Route path='/countries' element={<Countries />} />
                    <Route path='/add-country' element={<AddCountry />} />
                    <Route path='/country/edit/:id' element={<EditCountry />} />

                    {/* Branch Routes */}
                    <Route path='/branches' element={<Branches />} />
                    <Route path='/add-branch' element={<AddBranch />} />
                    <Route path='/branch/edit/:id' element={<EditBranch />} />

                    {/* Department Routes */}
                    <Route path='/departments' element={<Departments />} />
                    <Route path='/add-department' element={<AddDepartment />} />
                    <Route path='/department/edit/:id' element={<EditDepartment />} />

                    {/* Role Routes */}
                    <Route path='/roles' element={<Roles />} />
                    <Route path='/add-role' element={<AddRole />} />
                    <Route path='/role/edit/:id' element={<EditRole />} />

                    {/* Technology Routes */}
                    <Route path='/technologies' element={<Technologies />} />
                    <Route path='/add-technology' element={<AddTechnology />} />
                    <Route path='/technology/edit/:id' element={<EditTechnology />} />

                    {/* Responsibility Routes */}
                    <Route path='/responsibilities' element={<Responsibilities />} />
                    <Route path='/add-responsibility' element={<AddResponsibility />} />
                    <Route path='/responsibility/edit/:id' element={<EditResponsibility />} />

                    {/* User Routes */}
                    <Route path='/users' element={<Users />} />
                    <Route path='/add-user' element={<AddUser />} />
                    <Route path='/user/edit/:id' element={<EditUser />} />
                    <Route path='/user/:id/show' element={<UserDetails />} />

                    {/* Project Routes */}
                    <Route path='/projects' element={<Projects />} />
                    <Route path='/project/:id' element={<ProjectDetailsPage />} />
                    <Route path='/add-project' element={<AddProject />} />
                </Route>

                {/* Protected Routes Employee */}
                <Route element={<EmployeeLayout />}>
                    <Route path='/user-dashboard' element={<UserDashboard />} />
                    <Route path='/my-technologies' element={<MyTechnologies />} />
                    <Route path='/add-self-technology' element={<AddSelfTechnology />} />
                    <Route path='/profile' element={<UserProfilePage />} />
                    <Route path='/my-projects' element={<Projects />} />
                    <Route path='/my-project/:id' element={<ProjectDetailsPage />} />
                    <Route path='/me/add-project' element={<AddProject />} />
                </Route>
            </Routes>
        </UserInfoProvider>
    )
}
